import React from "react";
import { Layout, theme } from "antd";
import { Content, Footer, Header } from "antd/es/layout/layout";
import { Logo } from "../../components/ui";
import { DisplayComponent } from "./DisplayComponent";

interface Props {
  children: JSX.Element | JSX.Element[];
}
export const PublicLayout = ({ children }: Props) => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout>
      <Header
        style={{
          padding: 15,
          background: colorBgContainer,
          minHeight: "15vh",
          marginBottom: "10px",
          textAlign: "center",
        }}
      >
        <div />
        <Logo mobile={false} />
      </Header>
      <DisplayComponent error={false} isLoading={false}>
        <Content style={{ padding: "0 50px" }}>
          <div
            style={{
              padding: 24,
              minHeight: "72vh",
            }}
          >
            {children}
          </div>
        </Content>
      </DisplayComponent>
      <Footer style={{ textAlign: "center", background: colorBgContainer }}>
        ©Copyright Quattro Software, {new Date().getFullYear()}
      </Footer>
    </Layout>
  );
};
